module.exports = __webpack_public_path__ + "themes/mf/img/scratch-bg@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/scratch-bg@2x.png
// module id = 107
// module chunks = 3